import { showToast } from 'shared/toast/showToast'
import { Registry } from 'src/types/registry'
import UnmarkedAsPurchasedToast from './UnmarkedAsPurchasedToast'

export const showUnmarkedAsPurchasedToast = (
  registry: Registry,
  text = 'Unmarked as purchased.'
) =>
  showToast({
    render: (isOpen, handleDismiss) => (
      <UnmarkedAsPurchasedToast
        handleDismiss={handleDismiss}
        isOpen={isOpen}
        registry={registry}
        text={text}
      />
    ),
    timeout: 5000,
  })
